import { FundriseRouteConfig } from 'vue-router';
import { midYearReviewId } from '@constants/investor-update';

const marketingRedirectRoutes: Array<FundriseRouteConfig> = [
	{
		path: '/midyear',
		name: 'mid-year-review',
		meta: { minTokenScopeRequired: 'UNAUTHENTICATED' },
		redirect: {
			name: 'investor-update',
			params: {
				investorUpdateId: midYearReviewId
			}
		}
	},
	{
		path: '/pro',
		name: 'pro',
		meta: { minTokenScopeRequired: 'UNAUTHENTICATED' },
		redirect: { name: 'home' }
	}
];

export default marketingRedirectRoutes;
